import { ComponentInternalInstance, computed, getCurrentInstance } from '@vue/composition-api';
import i18n, { i18n_t } from '@/locales/i18n';
import ConstantConfig from '@/renderer/scripts/utils/ConstantConfig';
type Validator = {
  validator: {};
  rules: {
    phoneNumber: any[];
    sms: any[];
    email: any[];
    nickname: any[];
    comment: any[];
    teamName: any[];
  };
};
type IgnoreField = 'phoneNumber' | 'sms' | 'email' | 'nickname' | 'comment' | 'teamName' | 'account';

// 账号规则
const accountNameReg = /^[\da-zA-Z][\w.\-@]{1,62}[\da-zA-Z]$/;
// 密码规则
export const passwordReg = /^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~])[\x21-\x7E]{8,100}$/;

// 当为国内区号正则校验11位，其他国际区号校验为正整数
export function validatePhoneNumber(countryCode: string, phoneNumber: string) {
  if (countryCode === '+86') {
    const reg = /^1[3-9]\d{9}$/;
    return reg.test(phoneNumber);
  }
  const reg = /^\d{0,20}$/;
  return reg.test(phoneNumber);
}
export function validateSMS(smsStr: string) {
  const reg = /^\d{5,6}$/;
  if (smsStr && smsStr.length > 0) {
    return reg.test(smsStr);
  }
  return false;
}
export function validateAccountName(accountName: string) {
  return accountNameReg.test(accountName);
}
export default function userValidator(formData?: any, ignoreFields: IgnoreField[] = []): Validator {
  const currComponent: ComponentInternalInstance = getCurrentInstance() as ComponentInternalInstance;
  const vm = currComponent.proxy;
  const countryCode = computed(() => formData.countryCode || formData.code);
  const validator = {
    nickname(name: string) {
      return name.length <= ConstantConfig.nicknameMaxLength;
    },
    teamNameLength(name: string) {
      return name.length <= ConstantConfig.teamNameMaxLength;
    },
    teamNameReg(name: string) {
      return !name.includes('/');
    },
    comment(comment: string) {
      return comment.length <= ConstantConfig.commentMaxLength;
    },
    // 当为国内区号正则校验11位，其他国际区号校验为正整数
    phoneNumber(phoneStr: string) {
      if (countryCode.value === '+86') {
        const reg = /^1[3-9]\d{9}$/;
        return reg.test(phoneStr);
      }
      const reg = /^\d{0,20}$/;
      return reg.test(phoneStr);
    },
    sms(smsStr: string) {
      const reg = /^\d{5,6}$/;
      if (smsStr && smsStr.length > 0) {
        return reg.test(smsStr);
      }
      return true;
    },
    email(emailStr: string) {
      const reg = /^([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
      return reg.test(emailStr);
    },
    account(account: string) {
      return accountNameReg.test(account);
    },
    password(pwd: string) {
      return passwordReg.test(pwd);
    },
    passwordLength(pwd: string) {
      return pwd.length >= 8 && pwd.length <= 100;
    },
  };
  const rules = {
    phoneNumber: [
      {
        required: true,
        message: i18n_t('手机号必填'),
        type: 'error',
        trigger: 'change',
      },
      {
        validator: validator.phoneNumber,
        message: i18n_t('请输入正确的手机号码'),
      },
    ],
    sms: [
      // { required: false, message: '验证码必填', type: 'error', trigger: 'change' },
      {
        validator: validator.sms,
        message: i18n_t('请输入正确的验证码'),
      },
    ],
    email: [
      {
        validator: validator.email,
        message: i18n_t('邮箱格式不正确'),
        type: 'error',
        trigger: 'change',
      },
    ],
    nickname: [
      {
        required: true,
        message: i18n_t('用户昵称必填'),
        type: 'error',
        trigger: 'change',
      },
      {
        validator: validator.nickname,
        message: i18n_t('用户昵称字数超出限制'),
      },
    ],
    comment: [
      {
        validator: validator.comment,
        message: i18n_t('备注字数超出限制'),
      },
    ],
    teamName: [
      {
        validator: validator.teamNameLength,
        message: i18n_t('团队名称字数超出限制'),
      },
      {
        validator: validator.teamNameReg,
        message: i18n_t('团队名称不支持字符“/”'),
      },
    ],
    account: [
      {
        required: true,
        message: i18n_t('账号必填'),
        type: 'error',
        trigger: 'change',
      },
      {
        validator: validator.account,
        message: i18n_t('账号格式不正确，请重新输入'),
      },
    ],
    // 登录时账号只校验必填 不校验格式
    loginAccount: [
      {
        required: true,
        message: i18n_t('账号必填'),
        type: 'error',
        trigger: 'change',
      },
    ],
    loginPassword: [
      {
        required: true,
        message: i18n_t('密码必填'),
        type: 'error',
        trigger: 'change',
      },
    ],
    // 新增账号时只校验密码长度
    createPassword: [
      {
        required: true,
        message: i18n_t('密码必填'),
        type: 'error',
        trigger: 'change',
      },
      {
        validator: validator.passwordLength,
        message: i18n_t('密码长度需在8-100位字符之间，请重新输入'),
      },
    ],
    password: [
      {
        required: true,
        message: i18n_t('密码必填'),
        type: 'error',
        trigger: 'change',
      },
      {
        validator: validator.password,
        message: i18n_t('密码格式不正确，请重新输入'),
      },
    ],
  };
  // 处理忽略的字段
  ignoreFields.forEach(field => {
    rules[field] = [];
  });
  return {
    validator,
    rules,
  };
}
